"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importDefault(require("react"));
var TOP = 'top';
var LEFT = 'left';
var TOP_LEFT = 'top-left';
var getTooltipStyles = function (target, direction) {
    var top = window.pageYOffset + target.top;
    var left = window.pageXOffset + target.left;
    switch (direction) {
        case TOP:
            return {
                top: top + target.height,
                left: left + target.width / 2,
            };
        case LEFT:
            return {
                top: top + target.height / 2,
                left: left + target.width,
            };
        case TOP_LEFT:
        default:
            return {
                top: top + target.height,
                left: left,
            };
    }
};
/**
 * A tooltip, with arbitrary content.
 */
var Tooltip = function (_a) {
    var target = _a.target, children = _a.children, direction = _a.direction;
    return (react_1["default"].createElement("div", { style: getTooltipStyles(target, direction), className: "Tooltip Tooltip--" + direction, role: "tooltip" }, children));
};
Tooltip.propTypes = {
    target: prop_types_1["default"].shape({
        top: prop_types_1["default"].number.isRequired,
        left: prop_types_1["default"].number.isRequired,
        width: prop_types_1["default"].number.isRequired,
        height: prop_types_1["default"].number.isRequired,
    }).isRequired,
    direction: prop_types_1["default"].oneOf([TOP, LEFT, TOP_LEFT]).isRequired,
    children: prop_types_1["default"].node.isRequired,
};
exports["default"] = Tooltip;
